const SIGNUP_DISABLED_MESSAGE = "Sign-ups are currently disabled. Check back later!";

function normalizeMessage(value) {
  const text = String(value || "").trim();
  return text || null;
}

function maybeParseJson(value) {
  const text = normalizeMessage(value);
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch (_) {
    return null;
  }
}

function deriveFriendlyMessage(value) {
  if (!value) return null;

  if (typeof value === "string") {
    const parsed = maybeParseJson(value);
    if (parsed) return deriveFriendlyMessage(parsed);

    if (value.includes("signup_disabled")) {
      return SIGNUP_DISABLED_MESSAGE;
    }

    return normalizeMessage(value);
  }

  if (Array.isArray(value)) {
    for (const entry of value) {
      const message = deriveFriendlyMessage(entry);
      if (message) return message;
    }
    return null;
  }

  if (typeof value === "object") {
    const errorCode = normalizeMessage(value.error_code);
    const code = normalizeMessage(value.code);
    if (errorCode === "signup_disabled" || code === "signup_disabled") {
      return SIGNUP_DISABLED_MESSAGE;
    }

    const candidates = [
      value.error,
      value.message,
      value.error_description,
      value.details,
      value.hint,
    ];
    for (const candidate of candidates) {
      const message = deriveFriendlyMessage(candidate);
      if (message) return message;
    }
  }

  return null;
}

export function toFriendlyError(error, fallbackMessage = "Request failed.") {
  const contextBodyMessage = deriveFriendlyMessage(error?.context?.body);
  if (contextBodyMessage) return new Error(contextBodyMessage);

  const directMessage = deriveFriendlyMessage(error);
  if (directMessage) return new Error(directMessage);

  return new Error(fallbackMessage);
}

